"use client"

import React from "react"

import BreakFromCentered from "@/shared-module/common/components/Centering/BreakFromCentered"
import type { PartnerProps } from "@/shared-module/common/components/Partner"
import Partner from "@/shared-module/common/components/Partner"
import withErrorBoundary from "@/shared-module/common/utils/withErrorBoundary"

import type { BlockRendererProps } from ".."

const PartnersBlock: React.FC<React.PropsWithChildren<BlockRendererProps<PartnerProps>>> = (
  props,
) => {
  return (
    <BreakFromCentered sidebar={false}>
      {/* oxlint-disable-next-line typescript/no-explicit-any */}
      <Partner logos={props.data.innerBlocks as any} />
    </BreakFromCentered>
  )
}
export default withErrorBoundary(PartnersBlock)
